
export const MOBILE_NAVBAR_HEIGHT = 78;
export const DESKTOP_NAVBAR_HEIGHT = 66;